import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/demo/shared/shared.module';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { BaseEntryComponent } from './base-entry/base-entry.component';
import { BasePageToolsComponent } from './base-page-tools/base-page-tools.component';
import { BaseFilterComponent } from './base-page-tools/base-filter/base-filter.component';
import { BaseGridComponent } from './base-grid/base-grid.component';
import { BaseCriteriaComponent } from './base-criteria/base-criteria.component';
import { BaseCreateComponent } from './base-create/base-create.component';
import { BaseCreateToolsComponent } from './base-create/base-create-tools/base-create-tools.component';
import { RouterModule } from '@angular/router';
import { BaseViewComponent } from './base-view/base-view.component';
import { NgxAngularQueryBuilderModule } from '../global/ngx-angular-query-builder.module';
import { BaseInfoComponent } from './base-info/base-info.component';
import { BaseNotesComponent } from './base-notes/base-notes.component';
import { BaseAttachComponent } from './base-attach/base-attach.component';
import { BaseAttachViewComponent } from './base-attach/base-attach-view/base-attach-view.component';
import { BaseFieldConfigComponent } from './base-field-config/base-field-config.component';
import { BaseUploadTemplateComponent } from './base-upload-template/base-upload-template.component';
import { BaseFormLabelComponent } from './base-form-label/base-form-label.component';
import { BaseSendSMSComponent } from './base-send-sms/base-send-sms.component';
import { BaseSendWahtsupComponent } from './base-send-wahtsup/base-send-wahtsup.component';
import { BaseSendMailComponent } from './base-send-mail/base-send-mail.component';
import { QuillModule } from 'ngx-quill';
import { StimulsoftViewerModule } from 'stimulsoft-viewer-angular';
import { BaseFormInputComponent } from './base-form/base-form-input/base-form-input.component';
import { BasePasswordInputComponent } from './base-form/base-password-input/base-password-input.component';
import { BaseFormPhoneInputComponent } from './base-form/base-form-phone-input/base-form-phone-input.component';
import { NgxIntlTelephoneInputModule } from 'ngx-intl-telephone-input';
import { BaseFormCreateComponent } from './base-form-create/base-form-create.component';
import { BaseFormCreateToolsComponent } from './base-form-create/base-form-create-tools/base-form-create-tools.component';
import { ErrorComponent } from './base-form/error/error.component';
import { RangeDatePickerComponent } from './base-form/date-picker/range-date-picker/range-date-picker/range-date-picker.component';
import { BaseDropdownComponent } from './base-form/base-dropdown/base-dropdown.component';
import { UploadComponent } from './upload/upload.component';
import { BaseToolBarComponent } from './base-tool-bar/base-tool-bar.component';
import { PageToolsComponent } from './base-tool-bar/page-tools/page-tools.component';
import { InputWithSqlSearchComponent } from './base-form/input-with-sql-search/input-with-sql-search.component';
import { AutoCompleteComponent } from './base-form/auto-complete/auto-complete.component';
import { BaseReportPageToolBarComponent } from './base-report-page-tool-bar/base-report-page-tool-bar.component';
import { InputPopUpSearchComponent } from './base-form/input-pop-up-search/input-pop-up-search.component';
import { PopUpSearchWithoutSqlComponent } from './base-form/input-pop-up-search/pop-up-search-without-sql/pop-up-search-without-sql.component';
import { PhoneFormatPipe } from '../../pipes/phoneFormat/phone-format.pipe';
import { MmYyDatePickerComponent } from './base-form/date-picker/mm-yy-date-picker/mm-yy-date-picker.component';
import { DatePickerComponent } from './base-form/date-picker/date-picker/date-picker.component';
import { FormTextareaComponent } from './base-form/form-textarea/form-textarea.component';
import { BaseEntryFooterComponent } from './base-entry-footer/base-entry-footer.component';
import { FooterEntryPageToolsComponent } from './base-entry-footer/footer-entry-page-tools/footer-entry-page-tools.component';
import { FormMultiselectComponent } from './base-form/form-multiselect/form-multiselect.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { CalendarModule } from 'primeng/calendar';
import { MonthPickerComponent } from './base-form/date-picker/month-picker/month-picker.component';
import { YearPickerComponent } from './base-form/date-picker/year-picker/year-picker.component';
import { MonthYearPickerComponent } from './base-form/date-picker/month-year-picker/month-year-picker.component';
import { BaseSimpleFormComponent } from './base-simple-form/base-simple-form.component';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { TooltipModule } from 'primeng/tooltip';
import { PTimePickerComponent } from './base-form/time-picker/p-time-picker/p-time-picker.component';
import { MatTimePickerComponent } from './base-form/time-picker/mat-time-picker/mat-time-picker.component';
import { BaseCardsComponent } from './base-cards/base-cards.component';
import { CustomPaginationComponent } from '../global/custom-pagination/custom-pagination.component';
import { FormFieldWrapperComponent } from './form-field-wrapper/form-field-wrapper.component';
import { BaseIconSelectorComponent } from './base-form/base-icon-selector/base-icon-selector.component';

@NgModule({
  declarations: [
    BaseEntryComponent, BasePageToolsComponent, BaseFilterComponent,
    BaseGridComponent, BaseCriteriaComponent, BaseCreateToolsComponent,
    BaseCreateComponent, BaseViewComponent, BaseInfoComponent,
    BaseNotesComponent, BaseAttachComponent, BaseAttachViewComponent,
    BaseFieldConfigComponent, BaseUploadTemplateComponent, BaseFormLabelComponent,
    BaseSendSMSComponent, BaseSendWahtsupComponent, BaseSendMailComponent,
    BaseFormInputComponent, BasePasswordInputComponent, BaseFormPhoneInputComponent,
    BaseFormCreateComponent, BaseFormCreateToolsComponent,
    MmYyDatePickerComponent, DatePickerComponent, MonthPickerComponent, YearPickerComponent, MonthYearPickerComponent,
    ErrorComponent, RangeDatePickerComponent, BaseDropdownComponent, UploadComponent,
    BaseToolBarComponent, PageToolsComponent, InputWithSqlSearchComponent, FormTextareaComponent,
    AutoCompleteComponent, BaseReportPageToolBarComponent, InputPopUpSearchComponent,
    PopUpSearchWithoutSqlComponent, BaseEntryFooterComponent, FooterEntryPageToolsComponent,
    FormMultiselectComponent, PTimePickerComponent, MatTimePickerComponent,
    FormFieldWrapperComponent, BaseIconSelectorComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    NgxDatatableModule,
    RouterModule,
    NgxAngularQueryBuilderModule,
    QuillModule,
    StimulsoftViewerModule,
    NgxIntlTelephoneInputModule,
    PhoneFormatPipe,
    MultiSelectModule,
    CalendarModule,
    TooltipModule,
    BaseCardsComponent,
    CustomPaginationComponent,
  ],
  exports: [
    BaseEntryComponent, BasePageToolsComponent, BaseFilterComponent,
    BaseGridComponent, BaseCriteriaComponent, BaseCreateToolsComponent,
    BaseCreateComponent, BaseViewComponent, BaseInfoComponent,
    BaseNotesComponent, BaseAttachComponent, BaseAttachViewComponent,
    BaseFieldConfigComponent, BaseUploadTemplateComponent, BaseFormLabelComponent,
    BaseSendSMSComponent, BaseSendWahtsupComponent, BaseSendMailComponent,
    BaseFormInputComponent, BasePasswordInputComponent, BaseFormPhoneInputComponent,
    MmYyDatePickerComponent, ErrorComponent, RangeDatePickerComponent, DatePickerComponent,
    MonthPickerComponent, YearPickerComponent, MonthYearPickerComponent,
    BaseFormCreateComponent, BaseDropdownComponent, UploadComponent, BaseToolBarComponent,
    PageToolsComponent, InputWithSqlSearchComponent, AutoCompleteComponent,
    BaseReportPageToolBarComponent, InputPopUpSearchComponent, PopUpSearchWithoutSqlComponent,
    FormTextareaComponent, BaseEntryFooterComponent, FooterEntryPageToolsComponent,
    FormMultiselectComponent, PTimePickerComponent, MatTimePickerComponent,
    BaseCardsComponent, FormFieldWrapperComponent, BaseIconSelectorComponent
  ]
})
export class BaseModule { }
